import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");

var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var IndividualScoringGraph = require("components/data/graphs/IndividualScoringGraph")
var DigestProgressGraph = require("components/data/graphs/DigestProgressGraph")
var DigestGraphWithDropdown = require("components/data/graphs/DigestGraphWithDropdown")
var RubricRadarGraph = require("components/data/graphs/RubricRadarGraph")
var PaywallModal = require("components/users/teachers/PaywallModal")
var PaywallLink = require("components/users/teachers/PaywallLink");
var EmptyStateContainer = require("components/utility/EmptyStateContainer");
var StudentSelectorSidebar = require("components/data/StudentSelectorSidebar");
var StudentListDropdownDisplay = require("components/org/StudentListDropdownDisplay");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var SkillsetsPage = require("components/data/SkillsetsPage")

import {AVG_ANSWER_SCORE, AVG_QUIZ_SCORE, STUDENT, STUDENT_LIST, TEACHER, SCHOOL_ORG, DISTRICT_ORG } from "components/data/graphs/GraphUtility"
import _ from "underscore";

const INDIVIDUAL_VIEW = 'individual-view';
const STUDENT_LIST_VIEW = 'student-list-view';
const TEACHER_VIEW = 'teacher-view'
const SCHOOL_ORG_VIEW = 'school-org-view'
const DISTRICT_ORG_VIEW = 'district-org-view'

const SCORING = 'scoring-graph-view'
const ACTIVITY = 'activity-graph-view'
const SKILLSET = 'skillset-graph-view'
const INTERVENTION = 'intervention-graph-view'

const GRAPH_VIEW_KEYS = {[SCORING]: 'Scoring', [ACTIVITY]: 'Activity', [SKILLSET]: "Skillset", [INTERVENTION]: "Intervention" }
require("data/teacher_insights_page.scss")

@connect(
	(state, props) => ({
        user: RosterSelectors.admin({ state, id: CurrentUser.get().id }),
        studentLists: RosterSelectors.studentListsByAdminId({ state, adminId: CurrentUser.get().id }),
        showPaywall: !CurrentUser.get().account.gold_features
    }),
	(dispatch, props) => {
        var fetchStudentLists = function() {
			return dispatch(RosterActions.fetchStudentLists({
				embeds: ["student_list.students","student.prefs", "student.current_reading_level", "student_list.primary_admin", "student_list.admin_ids"]
			}))
		}

        var fetchStudentList = function (id) {
			return dispatch(RosterActions.fetchStudentList({
				id: id, 
				embeds: ["student_list.students", "student_list.grade_level", "student.prefs", "student.student_list.primary_admin", 'student.avatar']
			}))
		}

        var fetchTeachers = function(ids) {
            return dispatch(RosterActions.fetchAdmins({
                filters:{ids: ids}, 
                embeds:['user.prefs'],
                cache: true
            }))
        }

        var fetchSchoolOrgs = function(ids) {
            return dispatch(RosterActions.fetchSchoolOrgs({
                filters:{ids: [ids]}, 
                embeds:['school_org.prefs'],
                cache: true
            }))
        }

        var fetchDistrictOrg = function(id){
            return dispatch(RosterActions.fetchDistrictOrgs({
                filters:{ids: [id]}, 
                embeds:['district_org.prefs'],
                cache: true
            }))
        }

        // used to grab org_ids
        var fetchAdmin = function(){
            dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['admin.org_ids', 'user.prefs'],
                cache: false
            }))
        }

        var populateData = function() {
			return Promise.all([
				fetchStudentLists(),
                fetchAdmin()
			])
		}

        return {
            populateData,
            fetchStudentLists,
            fetchStudentList,
            fetchSchoolOrgs,
            fetchDistrictOrg,
            fetchTeachers
        }
    }
)

@providePopulateData({ waitForLoad: true })

class TeacherInsightsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

        if ($wr.getURLParameterByName("view")) {
			var initialView = $wr.getURLParameterByName("view");
		} else {
			var initialView = INDIVIDUAL_VIEW
		}

        if ($wr.getURLParameterByName("graph_view")) {
			var initialGraphView = $wr.getURLParameterByName("graph_view");
		} else {
			var initialGraphView = SCORING
		}

        var sortedStudentLists = $wr.sortByName(props.studentLists, "studentList");
        var initialActiveStudentList = sortedStudentLists[0]

        this.state = {
            studentLists: sortedStudentLists || null,
            teachers: null,
            schoolOrgs: null,
			activeStudent: null,
            activeStudentList: initialActiveStudentList,
            activeTeacher: null,
            activeSchoolOrg: null,
            activeDistrictOrg: null,
            studentsFetchedByListID: {},
            loading: false,
			currentView: initialView,
            graphView: initialGraphView
		}

        LuckyOrangeClient.tagComponent("NewInsightsPage");
    }

    fetchActiveData() {
		this.setState({ activeIndividualData: null, activeGroupData: null,
			activeAttributeIndex: null, activeTypeKey: "weak" });
	}

    onViewChange(view) {
		if (view != this.state.currentView) {
            // fetch data next
            this.setState({ currentView: view });
		}
	}

    graphPageChange(newPage){
        if (newPage != this.state.graphView) {
            this.setState({graphView: newPage})
        }
    }

    renderToggle(){
        var toggleOptions = [{ key: INDIVIDUAL_VIEW, text: "Individuals" }, 
			{ key: STUDENT_LIST_VIEW, text: "Classes" }];

        if (this.props.user.role == "adminRole" || this.props.user.role == "districtAdminRole") { 
            toggleOptions.push({key: TEACHER_VIEW, text: "Teachers"})
            toggleOptions.push({key: SCHOOL_ORG_VIEW, text: "Schools"})
        }
        if (this.props.user.role == "districtAdminRole"){
            toggleOptions.push({key: DISTRICT_ORG_VIEW, text: "District"})
        }
		var toggleDisplay = (
			<DisplayToggleControl options={ toggleOptions }
				onChange={ this.onViewChange } className="hideOnPrint"
				activeOptionKey={ this.state.currentView } />
		)
        return toggleDisplay
    }

    selectGraphView(graphView){
        this.setState({graphView: graphView})
    }

    renderGraphViewToggle(){
        var options = []
        for (const graphViewKey in GRAPH_VIEW_KEYS){
            options.push({key: graphViewKey, text: GRAPH_VIEW_KEYS[graphViewKey]})
        }

        return (
            <DisplayToggleControl options={ options }
                onChange={ this.graphPageChange } className='hideOnPrint'
                activeOptionKey={this.state.graphView}

            />
        )
    }

    renderSideBar(){
        if (this.state.currentView == STUDENT_LIST_VIEW){
            var sortedStudentLists = $wr.sortByName(this.state.studentLists, "studentList");
            var sidebar = (
                <div className='studentSelectorSidebar'>
                    <StudentListDropdownDisplay dropdownDisplay={"link"}
                        studentLists={sortedStudentLists}
                        currentStudentList={this.state.activeStudentList}
                        onChange={this.selectActiveStudentList.bind(this)} displayType={"mixed"} />
                </div>
            );
        } else if (this.state.currentView == INDIVIDUAL_VIEW && !this.state.loading) {
            var sidebar = (
                <StudentSelectorSidebar studentLists={this.state.studentLists}
                    activeStudentList={this.state.activeStudentList}
                    activeStudent={this.state.activeStudent}
                    onStudentListChange={this.selectActiveStudentList.bind(this)}
                    onStudentChange={this.selectActiveStudent.bind(this)}/>
            )
        } else if (this.state.currentView == TEACHER_VIEW){
            var teachersOptions = _.map(this.state.teachers, teacher=>(
                <ButtonDropdownOption
                    onClick={this.selectActiveTeacher.bind(this, teacher)}
                    text={`${teacher.first_name} ${teacher.last_name}`}
                    key={teacher.id}
                />
            ))

            var activeTeacherName = ""
            // add text at top of drop down
            if (this.state.activeTeacher){
                activeTeacherName = `${this.state.activeTeacher.first_name} ${this.state.activeTeacher.last_name}`
            }
            
            var sidebar = (
                <ButtonDropdown dropdownDisplay='link' text={activeTeacherName}>
                    {teachersOptions}
                </ButtonDropdown>
            )
        } else if (this.state.currentView == SCHOOL_ORG_VIEW){
            var orgOptions = _.map(this.state.schoolOrgs, schoolOrg=>(
                <ButtonDropdownOption 
                    onClick={this.selectActiveTeacher.bind(this, schoolOrg)}
                    text={schoolOrg.name}
                    key={schoolOrg.id}
                />
            ))

            var activeOrgName = ""
            // add text at top of drop down
            if (this.state.activeSchoolOrg){
                activeOrgName = this.state.activeSchoolOrg.name
            }

            var sidebar = (
                <ButtonDropdown dropdownDisplay='link' text={activeOrgName}>
                    {orgOptions}
                </ButtonDropdown>
            )
        }

        return sidebar
    }
        // used to construct header for graphs
	getSchoolYear(){
		var yearStartMonth = this.props.user.prefs.school_year_start_month || 8
		var now = new Date()
		
		if (now.getMonth() >= yearStartMonth) {
			var startYear = now.getFullYear()
		} else {
			var startYear = now.getFullYear() - 1
		}

		var endYear = (startYear + 1).toString()

		return `${startYear}-${endYear.slice(2, 4)}`
	}

    // function that is responsible for rendering the content when 'skillsets' is selected
    renderSkillsetViews(entity, entityType){

        var barGraph = <DigestGraphWithDropdown entity={entity} entityType={entityType} rubricGraph/>
        var graph = (
            <div className='graphContainer'>
                <h2 className='containerLabel'>Monthly Performance</h2>
                {barGraph}
            </div>
        )
        return graph
    }

    // renders content when 'scoring' is selected
    renderScoringView(entity, entityType){
        // individual scoring graph is special case...
        if (entityType == STUDENT){
            var answerGraph = <IndividualScoringGraph activeStudentList={this.state.activeStudentList} students={[entity]} view='answer-view'/>
            var quizGraph = <IndividualScoringGraph activeStudentList={this.state.activeStudentList} students={[entity]} view='quiz-view'/>
        } else {
            var answerGraph = <DigestProgressGraph entity={entity} entityType={entityType} metrics={[AVG_ANSWER_SCORE]}/>
            var quizGraph = <DigestProgressGraph entity={entity} entityType={entityType} metrics={[AVG_QUIZ_SCORE]}/>
        }
        var graph = (
            <div className='graphContainer'>
                <h2 className='containerLabel'>Quizzes</h2>
                {quizGraph}
                <h2 className='containerLabel'>Answers</h2>
                {answerGraph}
            </div>
        )
        return graph
    }

    renderInterventionView(entity, entityType){
        return (
            <div>
                <h2 className='containerLabel'> Strengths & Weaknesses</h2>
                <SkillsetsPage entity={entity} entityType={entityType} studentLists={this.state.studentLists}/>
            </div>
        )
    }

    // Given the page view (scoring/activity/skillset, create a graph/s)
    createGraph(entity, entityType){
        if (this.state.graphView == SCORING){
            var graph = this.renderScoringView(entity, entityType)
        } else if(this.state.graphView == ACTIVITY){
            var graph = <DigestGraphWithDropdown entity={entity} entityType={entityType}/>   
        } else if (this.state.graphView == SKILLSET){ 
            var graph = this.renderSkillsetViews(entity, entityType)
        } else if (this.state.graphView == INTERVENTION){
            var graph = this.renderInterventionView(entity, entityType)
        }
        return graph
    }
    
    renderMainContent(){
        if (this.props.showPaywall) { return this.renderPaywall() }

        if (this.state.loading) { return }
        
        var entity = null
        var entityType = null
        var nameString = ""
        switch(this.state.currentView){
            case INDIVIDUAL_VIEW:
                if (!this.state.activeStudent) {return}
                entity = this.state.activeStudent
                entityType = STUDENT
                nameString = `${entity.first_name} ${entity.last_name}`
                break
            case STUDENT_LIST_VIEW:
                if (!this.state.activeStudentList) {return}
                entity = this.state.activeStudentList
                entityType = STUDENT_LIST
                nameString = entity.name
                break
            case TEACHER_VIEW:
                if (!this.state.activeTeacher) {return}
                entity = this.state.activeTeacher
                entityType = TEACHER
                nameString = `${entity.first_name} ${entity.last_name}`
                break
            case SCHOOL_ORG_VIEW:
                if (!this.state.activeSchoolOrg) {return}
                entity = this.state.activeSchoolOrg
                entityType = SCHOOL_ORG
                nameString = entity.name
                break

            case DISTRICT_ORG_VIEW:
                if (!this.state.activeDistrictOrg) {return}
                entity = this.state.activeDistrictOrg
                entityType = DISTRICT_ORG
                nameString = entity.name
        }
        

        var header = (
			<div className='nameAndYear'>
				<b className='ellipsisText'>{nameString}</b>
				<i>{this.getSchoolYear()}</i>
			</div>
		)
        
        
        return (
            <div >
                <div className='pageHeader'>
                    {header}
                </div>
                <div className='viewToggle'>
                    {this.renderGraphViewToggle()}
                </div>
                <div className='graphContainer'>
                    {this.createGraph(entity, entityType)}
                </div>
                
            </div>
        )
    }

    renderPaywall(){

        return (
            <div className='teacherInsightsPage'>
                <PaywallModal featureType={ PaywallModal.INSIGHTS } ref="paywallModal"/>
                <EmptyStateContainer statusText={ "To view in-depth data on activity and performance, upgrade to WR Gold." }
						imagePath={ require("empty-state/insights-individual.png") } />	
                <PaywallLink featureLocation={ PaywallLink.INSIGHTS } />
            </div>
        )
    }

    render(){
        return (
            <div className='container teacherInsightsPage'>
                <header className="pageHeader"> 
                    <h1 className="hideOnPrint"> Insights </h1>
                </header>
                {this.renderToggle()}
                <div className='row'>
                    <div className="col-sm-3">
                            { this.renderSideBar() }
                        </div>
                        <div className="col-sm-9 rightContent">
                            {this.renderMainContent()}
                        </div>

                    </div>
            </div>
        )
    }

    selectActiveStudent(student){
        this.setState({ activeStudent: student })
    }

    //adds student list to 
    selectActiveStudentList(studentList){
        // if student info already loaded in, don't fetch again.
        var id = studentList.id
        if (!this.state.studentsFetchedByListID[id]){
            this.setState({loading: true})
            var stateListCopy = [...this.state.studentLists]
            this.props.fetchStudentList(id).then(response => {
                var correctStudentArray = response.students // put new student information in array
                var listObj = { ...studentList }; // copy current list object
                var studentArr = { ...listObj.students }; // copy student infomration in current list object
                studentArr = correctStudentArray; // replace copy of old student information with new student information
                listObj.students = studentArr; // insert new student information into current list object
                // find the index of the list, replace i.
                var listIndex = stateListCopy.findIndex(list=>list.id == id)
                stateListCopy[listIndex] = listObj
                var IDHashCopy = {... this.state.studentsFetchedByListID}
                IDHashCopy[id] = true
                this.setState({ activeStudentList: listObj, studentLists: $wr.sortByName(stateListCopy, "studentList"), activeStudent: $wr.sortByName(listObj.students, "flexName")[0], studentsFetchedByListID: IDHashCopy, loading: false}) // add modified current list to state
            });
        } else { // if we already fetched it, don't do it again.
            this.setState({ activeStudentList: studentList, activeStudent: $wr.sortByName(studentList.students, "flexName")[0]}) // add modified current list to state
        }
    }

    selectActiveTeacher(teacher){
        this.setState({activeTeacher: teacher})
    }

    selectActiveSchoolOrg(org){
        this.setState({activeSchoolOrg: org})
    }

    componentDidMount(){
        var activeStudentList = this.props.studentLists[0]
        this.selectActiveStudentList(activeStudentList)
        if (this.props.showPaywall){
            this.refs.paywallModal.show();
        }
    }

    componentDidUpdate(prevProps, prevState){
        if (this.state.currentView == TEACHER_VIEW && prevState.currentView != TEACHER_VIEW){
            // if we have already loaded teachers, don't search again.
            if (this.state.teachers) {return}
            this.setState({loading: true})
            var ids = _.uniq(_.map(this.state.studentLists, sl=>sl.primary_admin))
            this.props.fetchTeachers(ids).then(res=>{
                var sortedTeachers = $wr.sortByName(res.admins, "lastName")
                var activeTeacher = null
                if (sortedTeachers.length > 0) {var activeTeacher = sortedTeachers[0]}
                
                this.setState({activeTeacher: activeTeacher, teachers: sortedTeachers, loading: false})
            })
        } else if (this.state.currentView == SCHOOL_ORG_VIEW && prevState.currentView != SCHOOL_ORG_VIEW){
            if (this.state.schoolOrgs) {return}
            this.setState({loading: true})
            var ids = _.get(this.props.user, ['org_ids', 'school_orgs', 'all'], [])
            this.props.fetchSchoolOrgs(ids).then(res=>{
                var activeSchoolOrg = null
                if (res.schoolOrgs.length > 0) {var activeSchoolOrg = res.schoolOrgs[0]}
                
                this.setState({activeSchoolOrg: activeSchoolOrg, schoolOrgs: res.schoolOrgs, loading: false})
            })
        } else if (this.state.currentView == DISTRICT_ORG_VIEW && prevState.currentView != DISTRICT_ORG_VIEW){
            if (this.state.activeDistrictOrg) {return}
            this.setState({loading: true})
            var ids = _.get(this.props.user, ['org_ids', 'district_orgs', 'all'], [])
            this.props.fetchDistrictOrg(ids[0]).then(res=>{
                var activeDistrictOrg = null
                if (res.districtOrgs.length > 0) {var activeDistrictOrg = res.districtOrgs[0]}
                
                this.setState({activeDistrictOrg: activeDistrictOrg, loading: false})
            })
        }
    }
}

TeacherInsightsPage.propTypes = PageStrictPropTypes({ 
});

module.exports = TeacherInsightsPage;


// WEBPACK FOOTER //
// ./modules/components/data/TeacherInsightsPage.js